import { Gavel, ListChecks, Briefcase, MessageSquare, Bell, FileText } from "lucide-react";

export function notifIcon(type = "") {
  if (type.startsWith("hearing")) return Gavel;
  if (type.startsWith("task")) return ListChecks;
  if (type.startsWith("case")) return Briefcase;
  if (type === "document_shared") return FileText;
  if (type.startsWith("client")) return MessageSquare;
  return Bell;
}

export function timeAgo(isoStr) {
  if (!isoStr) return "";
  const d = new Date(isoStr);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}
